if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('video[autoplay]').forEach((video) => {
      video.removeAttribute('autoplay');
      video.pause();
    });

    document.querySelectorAll('iframe[src*="autoplay=1"]').forEach((iframe) => {
      const url = new URL(iframe.src);
      url.searchParams.set('autoplay', '0');
      url.searchParams.delete('background');
      iframe.src = url.toString();
    });
  });
}
